<template>
    <div>
        <div class="d-flex flex-column-fluid">
            <!--begin::Container-->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class=" card card-custom gutter-b bg-transparent shadow-none border-0">
                                    <div
                                        class=" card-header align-items-center border-bottom-dark px-0">
                                        <div class="card-title mb-0">
                                            <h3 v-if="sale.order_id" class="card-label mb-0 font-weight-bold text-body">Заказ №{{sale.order_id}}</h3>
                                            <h3 v-else class="card-label mb-0 font-weight-bold text-body">Новый заказ </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="text-body">Использовать данные с запроса</label>
                                                    <fieldset class="form-group mb-3">
                                                        <select
                                                            @change="getQuotation()" v-model="selectedQuotation" class="js-states form-control bg-transparent">
                                                            <option value="">Выбрать запрос</option>
                                                            <option v-for="quotation in quotations" v-bind:value="quotation.id">{{ quotation.id }}</option>
                                                        </select>
                                                    </fieldset>
                                                    <label class="text-body">Клиент</label>
                                                    <fieldset class="form-group mb-3">
                                                        <multiselect
                                                            v-model="sale.customer"
                                                            :options="customers"
                                                            :custom-label="customerNameSurname"
                                                            placeholder="Выбрать клиента"
                                                            label="name"
                                                            track-by="customer_id"
                                                            :multiple="false"
                                                            :taggable="true"
                                                            @select="getSelectedCustomerData"
                                                        >
                                                        </multiselect>
                                                        <small class="form-text text-danger" v-if="errors.has('customer')" v-text="errors.get('customer')"></small>
                                                    </fieldset>

                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <label class="text-body">Адрес</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_street_address"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_street_address')" v-text="errors.get('billing_street_address')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                            <label class="text-body">ZIP</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_postcode"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_postcode')" v-text="errors.get('billing_postcode')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Город</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_city"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_city')" v-text="errors.get('billing_city')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-12">
                                                        <label class="text-body">Страна</label>

                                                        <fieldset class="form-group mb-3">
                                                            <multiselect
                                                                @input="computeValues('updateCountry')"
                                                                v-model="sale.billing_country"
                                                                :options="countries"
                                                                :custom-label="countryName"
                                                                placeholder="Выбрать страну"
                                                                label="name"
                                                                track-by="country_id"
                                                                :multiple="false"
                                                                :taggable="true"
                                                            >
                                                            </multiselect>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_country')" v-text="errors.get('billing_country')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                        <label class="text-body">Эл. Почта</label>
                                                        <fieldset class="form-group mb-3">
                                                            <input type="text" class="form-control bg-white" value="" v-model="sale.billing_email"/>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_email')" v-text="errors.get('billing_email')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                        <label class="text-body">Телефон</label>
                                                        <fieldset class="form-group mb-3">
                                                            <input type="text" class="form-control bg-white" value="" v-model="sale.billing_phone"/>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_phone')" v-text="errors.get('billing_phone')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-12 mb-3">
                                                            <span class="text-dark">Юр. лицо</span>
                                                            <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                                                <input
                                                                    @change="computeValues('legalPerson')"
                                                                    type="checkbox"
                                                                    class="custom-control-input"
                                                                    v-model="sale.billing_is_legal_person"
                                                                    :id="`customSwitchStatus${sale.billing_is_legal_person}`"
                                                                    :checked="sale.billing_is_legal_person === 1"
                                                                />
                                                                <label class="custom-control-label mr-1" :for="`customSwitchStatus${sale.billing_is_legal_person}`"></label>
                                                            </div>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Нр. Регистрации</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_registration_number"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_registration_number')" v-text="errors.get('billing_registration_number')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Налоговый номер</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input @input="computeValues('updateCountry')" type="text" class="form-control bg-white" value="" v-model="sale.billing_tax_number"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_tax_number')" v-text="errors.get('billing_tax_number')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Юр. адрес</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_company_address"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_company_address')" v-text="errors.get('billing_company_address')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                        <label class="text-body">Компания</label>
                                                        <fieldset class="form-group mb-3">
                                                            <select
                                                                v-model="sale.company_id" class="js-states form-control bg-transparent">
                                                                <option value=""></option>
                                                                <option v-for="company in companies" v-bind:value="company.id">{{ company.name }}</option>
                                                            </select>
                                                        </fieldset>
                                                        </div>

                                                    </div>


                                                </div>

                                                <div class="col-md-6">
                                                    <label class="text-body">Склад</label>
                                                    <fieldset class="form-group mb-3">
                                                        <select
                                                            v-model="sale.warehouse_id"
                                                            class="js-states form-control bg-transparent"
                                                            @change="taxApply()"
                                                        >
                                                            <option value="">Выбрать склад</option>
                                                            <option v-for="warehouse in warehouses" v-bind:value="warehouse.warehouse_id">
                                                                {{ warehouse.warehouse_name }}
                                                            </option>
                                                        </select>
                                                        <small class="form-text text-danger" v-if="errors.has('warehouse_id')" v-text="errors.get('warehouse_id')" ></small>
                                                    </fieldset>

                                                    <label class="text-body">Дата продажи</label>
                                                    <fieldset class="form-group mb-3">
                                                        <input type="date" class="form-control bg-white" value="" v-model="sale.sale_date"/>
                                                        <small class="form-text text-danger" v-if="errors.has('sale_date')" v-text="errors.get('sale_date')" ></small>
                                                    </fieldset>

                                                    <label class="text-body">Метод оплаты</label>
                                                    <fieldset class="form-group mb-3">
                                                        <select
                                                            v-model="sale.payment_method_id"
                                                            class="js-states form-control bg-transparent"
                                                        >
                                                            <option value="">Выбрать метод оплаты</option>
                                                            <option
                                                                v-if="payment_method.payment_method_status == 1 "
                                                                v-for="payment_method in payment_methods"
                                                                v-bind:value="payment_method.payment_method_id"
                                                            >
                                                                {{ payment_method.payment_method_title || payment_method.payment_method_name }}
                                                            </option>
                                                        </select>
                                                        <small class="form-text text-danger" v-if="errors.has('payment_method_id')" v-text="errors.get('payment_method_id')" ></small>
                                                    </fieldset>
                                                    <label class="text-body">Метод доставки</label>
                                                    <fieldset class="form-group mb-3">
                                                        <select v-model="sale.shipping_method_id" class="js-states form-control bg-transparent" @change="fetchShippingOptions()">
                                                            <option value="">Выбрать метод доставки</option>
                                                            <option
                                                                v-for="shipping_method in shipping_methods"
                                                                v-bind:value="shipping_method.shipping_method_id"
                                                            >
                                                                {{ shipping_method.shipping_method_description[0].name }}
                                                            </option>
                                                        </select>
                                                        <small class="form-text text-danger" v-if="errors.has('shipping_method_id')" v-text="errors.get('shipping_method_id')"></small>
                                                    </fieldset>

                                                    <fieldset v-if="sale.shipping_method_id == 2">
                                                        <select v-model="sale.shipping_option_id" class="js-states form-control bg-transparent">
                                                            <option value="">Выбрать пакомат</option>
                                                            <option
                                                                v-for="shipping_option in shipping_options"
                                                                v-bind:value="shipping_option.shipping_option_id"
                                                            >
                                                                {{ shipping_option.shipping_option_link }}
                                                            </option>
                                                        </select>
                                                        <small class="form-text text-danger" v-if="sale.shipping_method_id == 2 && errors.has('shipping_option_id')" v-text="errors.get('shipping_option_id')"></small>
                                                    </fieldset>
                                                    <label class="text-body">Стоимость доставки</label>
                                                    <fieldset class="form-group mb-3">
                                                        <input type="text" class="form-control bg-white" value="" v-model="sale.shipping_cost"/>
                                                        <small class="form-text text-danger" v-if="errors.has('shipping_cost')" v-text="errors.get('shipping_cost')" ></small>
                                                    </fieldset>
                                                    <label v-if="sale.order_id" class="text-body">Статус заказа</label>
                                                    <fieldset v-if="sale.order_id" class="form-group mb-3">
                                                        <select v-model="sale.order_status_id" class="js-states form-control bg-transparent">
                                                            <option
                                                                v-for="order_status in order_statuses"
                                                                v-bind:value="order_status.order_status_id"
                                                            >
                                                                {{ statusName(order_status) }}
                                                            </option>
                                                        </select>
                                                        <small class="form-text text-danger" v-if="errors.has('shipping_method_id')" v-text="errors.get('shipping_method_id')"></small>
                                                    </fieldset>
                                                    <label class="text-body">Номер документа</label>
                                                    <fieldset class="form-group mb-3">
                                                        <input type="text" class="form-control bg-white" value="" v-model="sale.code"/>
                                                        <small class="form-text text-danger" v-if="errors.has('code')" v-text="errors.get('code')" ></small>
                                                    </fieldset>

                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <Offer v-if="type=='offer'"></Offer>
                            <div v-else class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div class="col-md-12" style="padding-right: 0; padding-left: 0">
                                            <label class="text-body">Товары</label>
                                            <fieldset class="form-group mb-3">
                                                <multiselect
                                                    v-model="productSearchSelection"
                                                    :options="productSearchResults"
                                                    :custom-label="productSearchLabel"
                                                    track-by="key"
                                                    placeholder="Найти товар по названию, артикулу или коду"
                                                    :internal-search="false"
                                                    :loading="productSearchLoading"
                                                    :options-limit="50"
                                                    selectLabel=""
                                                    selectedLabel=""
                                                    deselectLabel=""
                                                    @search-change="searchOrderFormProducts"
                                                    @select="addOrderFormItem"
                                                >
                                                    <span slot="noResult">Ничего не найдено</span>
                                                    <span slot="noOptions">Начните вводить название или артикул</span>
                                                </multiselect>
                                            </fieldset>
                                        </div>

                                        <div class="col-12" style="padding: 0" v-if="orderFormItems.length">
                                            <div class="table-responsive">
                                                <table class="table table-striped text-body" id="orderTable">
                                                    <thead>
                                                        <tr>
                                                            <th class="border-0 header-heading" scope="col">#</th>
                                                            <th class="border-0 header-heading" scope="col">Название</th>
                                                            <th class="border-0 header-heading" scope="col">Артикул</th>
                                                            <th class="border-0 header-heading" scope="col">Остаток</th>
                                                            <th class="border-0 header-heading" scope="col">Кол-во</th>
                                                            <th class="border-0 header-heading" scope="col">Цена с НДС</th>
                                                            <th class="border-0 header-heading" scope="col">НДС</th>
                                                            <th class="border-0 header-heading" scope="col">Сумма</th>
                                                            <th class="border-0 header-heading" scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(item, index) in orderFormItems" :key="item.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ item.title }}</td>
                                                        <td>{{ item.sku || '—' }}</td>
                                                        <td :class="{ 'text-danger': item.qty > item.available_qty }">
                                                            {{ item.available_qty }}
                                                        </td>
                                                        <td class="text-center" style="max-width: 120px">
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                class="form-control"
                                                                v-model.number="item.qty"
                                                                @change="updateOrderFormItem(item)"
                                                            />
                                                        </td>
                                                        <td class="text-center" style="max-width: 160px">
                                                            <div class="input-group">
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    class="form-control"
                                                                    v-model.number="item.price_with_vat"
                                                                    @change="updateOrderFormItem(item)"
                                                                />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center" style="max-width: 110px">
                                                            <select class="form-control"
                                                                    v-model.number="item.tax_rate"
                                                                    @change="updateOrderFormItem(item)">
                                                                <option v-for="rate in taxRates" :key="'r' + rate" :value="rate">
                                                                    {{ rate }}%
                                                                </option>
                                                            </select>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ item.line_total }} {{ currencySymbol }}
                                                        </td>
                                                        <td class="text-center">
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-light text-danger"
                                                                title="Убрать из заказа"
                                                                @click="removeOrderFormItem(item)"
                                                            >&times;</button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td colspan="3"><strong>Итого позиций</strong></td>
                                                        <td class="text-center"><strong>{{ productsCount }}</strong></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td class="text-center">
                                                            <strong>{{ orderFormTotals.goods_with_vat }} {{ currencySymbol }}</strong>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div class="row mb-3">
                                            <div class="col-6">
                                                <label>Внутренний комментарий:</label>
                                                <fieldset class="form-group mb-3">
                                                    <textarea
                                                          class="form-control"
                                                          id="label-textarea"
                                                          rows="6"
                                                          placeholder="Добавьте примечание"
                                                          style="height: 130px"
                                                          spellcheck="false"
                                                          v-model="sale.internal_note"
                                                      >{{ sale.internal_note }}
                                                    </textarea>
                                                </fieldset>
                                                <small class="form-text text-danger" v-if="errors.has('desc')" v-text="errors.get('desc')" ></small>
                                            </div>
                                            <div class="col-6">
                                                <label>Комментарий от клиента:</label>
                                                <fieldset class="form-group mb-3">
                                                    <textarea
                                                          class="form-control"
                                                          id="label-textarea"
                                                          rows="6"
                                                          placeholder="Добавьте примечание"
                                                          style="height: 130px"
                                                          spellcheck="false"
                                                          v-model="sale.bill_note"
                                                      >{{ sale.bill_note }}
                                                    </textarea>
                                                </fieldset>
                                                <small class="form-text text-danger" v-if="errors.has('desc')" v-text="errors.get('desc')" ></small>
                                            </div>
                                            <div class="col-12 d-none">
                                                <label>Купон</label>
                                                <fieldset class="form-group mb-3">
                                                    <select class="form-control" v-model="selectedCoupon">
                                                        <option v-for="coupon in coupons" :selected="coupon.id == selectedCoupon" v-bind:value="coupon" >
                                                            {{ coupon.coupon_code }}
                                                        </option>
                                                    </select>
                                                    <small class="form-text text-danger" v-if="errors.has('coupon')" v-text="errors.get('coupon')" ></small>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <Total :totals="offer_totals" v-if="type == 'offer'"></Total>
                                        <div v-else class="row justify-content-end">
                                            <div class="col-12 col-md-4">
                                                <div>
                                                    <table class="table right-table mb-0">
                                                        <tbody>
                                                        <tr class=" d-flex align-items-center justify-content-between" >
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark">
                                                                    Промежуточная сумма:
                                                                </h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ sale.subtotal }} {{ currencySymbol }}
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between"
                                                            v-for="line in vatBreakdown" :key="'vat' + line.rate">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark">В т.ч. НДС {{ line.rate }}%:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                {{ line.amount }} {{ currencySymbol }}
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between" v-if="!vatBreakdown.length">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Налог:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ (sale.tax_amount) }} {{ currencySymbol }}
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Доставка:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ shippingPrice }} {{ currencySymbol }}
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between">
                                                            <th class="border-0">
                                                                <h5
                                                                    class="font-size-h5 mb-0 font-size-bold text-dark">Итого:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                {{ (Number(sale.payable)+Number(shippingPrice)).toFixed(2) }} {{ currencySymbol }}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 d-flex justify-content-end" style="padding-left: 0; padding-right: 0">
                                            <button class="btn btn-light" style="margin-right: 8px" @click="save('stay')">Сохранить</button>
                                            <button class="btn btn-light" style="margin-right: 8px" @click="save('list')">Сохранить и вернуться в список</button>
                                            <button class="btn btn-primary" @click="save('close')">Сохранить и закрыть</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
import Multiselect from "vue-multiselect";
import Offer from "./Offer";
import Total from "./Total";

export default {
    components: {Multiselect, Offer, Total},
    data() {
        return {
            type: 'order',
            offer_totals: [],
            display_form: 0,
            warehouse_state_id: 4491,
            sale: {
                code: null,
                customer: [],
                warehouse_id: "",
                desc: "",
                payable: 0,
                tax_id: "",
                tax_amount: 0,
                tax_line_amount: [],
                tax_rate: [],
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                billing_street_address: "",
                billing_city: "",
                billing_country: "",
                billing_postcode: "",
                billing_email: "",
                billing_phone: "",
                billing_is_legal_person: 0,
                billing_company_address: "",
                order_id: 0,
                shipping_cost: 0,
                order_status_id: 1,
                internal_note: '',
                bill_note: '',
                company_id: '',
            },
            currency: [],
            product_id: [],
            combination_product_id: [],
            combination_products: [],
            customIndex: 0,
            display_table: false,
            searchParameter: "",
            sortBy: "id",
            sortType: "ASC",
            limit: 10,
            error_message: "",
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            sales: [],
            warehouses: [],
            countries: [],
            companies: [],
            customers: [],
            products: [],
            orderFormItems: [],
            orderFormTotals: {},
            vatBreakdown: [],
            taxRates: [],
            productSearchResults: [],
            productSearchSelection: null,
            productSearchLoading: false,
            productSearchTimer: null,
            payment_methods: [],
            shipping_methods: [],
            shipping_options: [],
            order_statuses: [],
            category_products: [],
            selectedProducts: [],
            token: [],
            taxes: [],
            quotations: [],
            selectedQuotation: "",
            selectedCustomerAddress: {},
            errors: new ErrorHandling(),
            tax_per_apply: 0,
            customer_address: [],
            coupons: [],
            selectedCoupon: {},
            selectedProductDropdown: {},
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
        };
    },
    methods: {
        productSearchLabel(option) {
            const stock = option.available_qty > 0 ? `остаток ${option.available_qty}` : 'нет в наличии';

            return `${option.title}${option.sku ? ' · ' + option.sku : ''} · ${option.price_with_vat} · ${stock}`;
        },
        searchOrderFormProducts(query) {
            clearTimeout(this.productSearchTimer);
            this.productSearchTimer = setTimeout(() => {
                this.productSearchLoading = true;
                const params = new URLSearchParams({
                    q: query || '',
                    warehouse_id: this.sale.warehouse_id || '',
                });

                axios
                    .get(`/api/admin/order-form/products?${params}`, this.token)
                    .then((res) => {
                        if (res.data.status === 'Success') {
                            this.productSearchResults = res.data.data.map(row => ({
                                ...row,
                                key: `${row.product_id}-${row.product_combination_id || 0}`,
                            }));
                        }
                    })
                    .finally(() => (this.productSearchLoading = false));
            }, 300);
        },
        addOrderFormItem(option) {
            if (!this.sale.customer || !this.sale.customer.customer_id) {
                this.$toaster.error('Сначала выберите клиента');
                return;
            }

            this.orderFormRequest('post', '/api/admin/order-form/items', {
                product_id: option.product_id,
                product_combination_id: option.product_combination_id,
                qty: 1,
            }).then(() => (this.productSearchSelection = null));
        },
        updateOrderFormItem(item) {
            this.orderFormRequest('put', `/api/admin/order-form/items/${item.id}`, {
                qty: item.qty,
                price_with_vat: item.price_with_vat,
                tax_rate: item.tax_rate,
            });
        },
        removeOrderFormItem(item) {
            this.orderFormRequest('delete', `/api/admin/order-form/items/${item.id}`);
        },
        // Every call answers with the whole row set and the totals, so the
        // browser never recalculates money on its own.
        orderFormRequest(method, url, data = {}) {
            const context = {
                customer_id: this.sale.customer ? this.sale.customer.customer_id : null,
                warehouse_id: this.sale.warehouse_id,
                shipping_cost: this.sale.shipping_cost || 0,
            };

            this.$parent.loading = true;

            const request = method === 'delete'
                ? axios.delete(`${url}?${new URLSearchParams(context)}`, this.token)
                : axios[method](url, { ...context, ...data }, this.token);

            return request
                .then((res) => {
                    if (res.data.status === 'Success') {
                        this.applyOrderForm(res.data.data);
                    }
                })
                .catch((error) => {
                    const message = error.response && error.response.data && error.response.data.message;
                    this.$toaster.error(message || 'Не удалось обновить состав заказа');
                })
                .finally(() => (this.$parent.loading = false));
        },
        applyOrderForm(data) {
            this.orderFormItems = data.items;
            this.orderFormTotals = data.totals;
            this.vatBreakdown = data.totals.vat_breakdown || [];
            this.taxRates = data.tax_rates || this.taxRates;
            this.display_table = data.items.length > 0;

            this.sale.subtotal = data.totals.subtotal_without_vat;
            this.sale.tax_amount = data.totals.tax_amount;
            this.sale.payable = data.totals.total;
        },
        loadOrderForm() {
            this.$parent.loading = true;

            return axios
                .post(`/api/admin/order-form/load/${this.$route.params.id}`, {}, this.token)
                .then((res) => {
                    if (res.data.status === 'Success') {
                        this.applyOrderForm(res.data.data);
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        resetOrderForm() {
            if (!this.sale.customer || !this.sale.customer.customer_id) {
                return Promise.resolve();
            }

            return this.orderFormRequest('post', '/api/admin/order-form/reset');
        },
        // Status names are localised; a fixed array index showed the English
        // variant regardless of the shop language.
        statusName(orderStatus) {
            const details = (orderStatus && orderStatus.detail) || [];

            if (!details.length) {
                return '';
            }

            const languageId = (window.appConfig && window.appConfig.defaultLanguageId) || 3;
            const localised = details.find(d => Number(d.language_id) === Number(languageId));

            return (localised || details[0]).name;
        },
        fetchSaleQuotations() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/sale_quotation", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.quotations = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCurrency() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/currency?is_default=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.currency = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        sumProductPrice(index){
            if(this.sale.price[index] && this.sale.discount_price_with_tax[index] && this.sale.qty[index] ){
                let sum = 1;
                if(this.sale.discount_price_with_tax[index] > 0) {
                    sum = this.sale.discount_price_with_tax[index] * this.sale.qty[index];
                } else {
                    sum = this.sale[this.sale.discount_price[index] > 0 ? 'discount_price' : 'price'][index] * this.sale.qty[index];
                    if(this.sale.tax_rate[index] > 0){
                        sum *= this.sale.tax_rate[index];
                    }
                }

                return parseFloat(sum).toFixed(2);
            }
            return 0;
        },
        fetchCountries() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/country?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.countries = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCompanies() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/companies", config)
                .then((res) => {
                    if (res.data.data) {
                        this.companies = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchWarehouses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/warehouse?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.warehouses = res.data.data;
                        this.sale.warehouse_id = res.data.data[0]?.warehouse_id;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchTaxes() {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios.get("/api/admin/tax", config).then((res) => {
                if (res.data.status == "Success") {
                    this.taxes = res.data.data;
                }
            });
        },
        fetchProducts() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            // Returned so the edit form can wait for the catalogue before it
            // tries to match the order rows against it.
            return axios
                .get(
                    "/api/admin/product?getAllData=1&getDetail=1&getCategory=1",
                    config
                )
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.products = res.data.data;

                        this.showSideBarProduct();
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCustomers() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            return axios
                .get("/api/admin/customer?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.customers = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchPaymentMethods() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/payment_method?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.payment_methods = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchShippingMethods() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/shipping_method?getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.shipping_methods = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchShippingOptions() {
            this.current_shipping_method = this.shipping_methods.filter(method => method.shipping_method_id == this.sale.shipping_method_id);
            if(this.current_shipping_method[0].shipping_method_has_options) {
                this.$parent.loading = true;
                var token = localStorage.getItem("token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };
                var responseData = {};

                axios
                    .get("/api/admin/shipping_method/"+this.sale.shipping_method_id+"/options", config)
                    .then((res) => {
                        if (res.data.status == "Success") {
                            this.shipping_options = res.data.data;
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            }

        },
        fetchOrderStatuses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/order-status", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.order_statuses = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        getSelectedCustomerData(selectedOption, id) {
            if (!this.$route.params.id) {
                this.$nextTick(() => this.resetOrderForm());
            }

            this.sale.billing_is_legal_person = selectedOption.customer_is_legal_person;
            this.sale.billing_tax_number = selectedOption.customer_tax_number;
            this.sale.billing_registration_number = selectedOption.customer_registration_number;
            this.sale.billing_email = selectedOption.customer_email;
            this.sale.billing_street_address = selectedOption.customer_address[0].street_address;
            this.sale.billing_city = selectedOption.customer_address[0].city;
            this.sale.billing_postcode = selectedOption.customer_address[0].postcode;
            this.sale.billing_country = selectedOption.customer_address[0].country_id;
            this.sale.billing_phone = selectedOption.customer_address[0].phone;
            this.sale.billing_company_address = selectedOption.company_address;
        },
        addsale() {
            this.$parent.loading = true;
            var url = "/api/admin/sale";
            if (this.edit === false) {
                // Add
                this.request_method = "post";
            } else {
                // Update
                var url = "/api/admin/sale/" + this.sale.id;
                this.request_method = "put";
            }
            this.sale.shipping_cost = parseFloat(this.sale.shipping_cost.toString().replace(',','.'))
            axios[this.request_method](url, this.sale, this.token)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.sale = {
                            saler_id: "",
                            sale_date: new Date().toISOString().substr(0, 10),
                            desc: "",
                            payable: 0,
                            amount_paid: 0,
                            discount: 0,
                            due_amount: 0,
                            product_id: [],
                            product_name: [],
                            product_combination_id: [],
                            price: [],
                            discount_price_with_tax: [],
                            qty: [],
                            warehouse_id: "",
                            subtotal: 0,
                            shipping_method_id,
                        };
                        this.errors = new ErrorHandling();
                        this.selectedProducts = [];
                        this.$toaster.success(res.data.message);
                    } else {
                        this.$toaster.error(res.data.message);
                    }
                })
                .catch((error) => {
                    this.error_message = "";
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == "Error") {
                            this.$toaster.error(error.response.data.message);
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    } else if (error.response.status == 500) {
                        this.$toaster.error(error.response.data.message);
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        computeValues: function (method, index = null) {
            // VAT divisor comes from the tax settings; it used to be hardcoded
            // as 1.21 while orders were being stored with another rate.
            const vatDivisor = 1 + ((window.appConfig && window.appConfig.orderTaxRate) || 22) / 100;

            if (this.sale.qty.length == this.sale.price.length) {
                //setting total counters
                let subtotal = 0;
                let sum = 0;
                let total = 0;
                let taxes = 0;

                console.log(this.sale)
                //going through each sale product
                for (var i = 0; i < this.sale.qty.length; i++) {

                    if(method === 'price' && index === i) {
                        this.sale.discount[i] = 0;
                    }
                    //discount with percentage
                    if(this.sale.discount[i] > 0) {
                        this.sale.discount_price_with_tax[i] = Number(this.selectedProducts[i].product_price_with_vat - (this.selectedProducts[i].product_price_with_vat * (this.sale.discount[i] / 100))).toFixed(2);
                        sum = Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i]/vatDivisor)
                        total = Number(total) + Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i])
                        taxes = Number(taxes) + Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i]) - Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i]/vatDivisor)
                        subtotal = Number(subtotal) + Number(sum);
                        console.log('discount if')
                    } else {
                        //standard price or standard discount price
                        console.log('standard if')
                        if(!this.sale.discount_price_with_tax[i]) {
                            this.sale.discount_price_with_tax[i] = this.sale.price[i];
                        }

                        if(this.sale.discount_price[i] > 0 && this.sale.discount_price[i] < this.sale.price[i]) {
                            sum = (this.sale.qty[i] * this.sale.discount_price[i])/vatDivisor;
                            this.sale.discount_price_with_tax[i] = this.sale.discount_price[i]
                            this.sale.discount[i] = Number((( this.sale.price[i] - this.sale.discount_price[i]) / this.sale.price[i]) * 100).toFixed(4);
                            if(this.sale.discount[i] > 0){
                                total = Number(total) + Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i])
                                taxes = Number(taxes) + Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i]) - Number(this.sale.qty[i]) * Number(this.sale.discount_price_with_tax[i]/vatDivisor)
                            }
                        } else {
                            // The row keeps its own price (B2B orders store a negotiated
                            // one); the catalogue price is only a fallback for new rows.
                            const rowPrice = Number(this.sale.discount_price_with_tax[i]);

                            sum = (this.sale.qty[i] * rowPrice)/vatDivisor;
                            total = Number(total) + Number(this.sale.qty[i]) * rowPrice;
                            taxes = Number(taxes) + (Number(this.sale.qty[i]) * rowPrice) - (Number(this.sale.qty[i]) * rowPrice)/vatDivisor;
                        }
                        subtotal = Number(subtotal) + Number(sum);
                    }
                    if(this.sale.discount[i] == 0) {
                        this.sale.discount[i] = '';
                    }
                }
                // Totals come from the server (VAT is per line there); recalculating
                // them here would overwrite a correct result with a rounded one.
                if (!this.orderFormItems.length) {
                    this.sale.subtotal = Number(subtotal).toFixed(2);
                    this.sale.payable = Number(total).toFixed(2);
                }


                if (!this.orderFormItems.length) {
                    if(this.sale.billing_country.country_name != 'Latvia' && this.sale.billing_tax_number  && this.sale.billing_is_legal_person != 0){
                        this.sale.tax_amount = 0;
                        this.sale.subtotal = Number(this.sale.payable - this.sale.shipping_cost).toFixed(2);
                    }else{
                        this.sale.tax_amount = Number(taxes).toFixed(2);
                    }
                }
                

                // this.sale.due_amount = this.sale.payable - this.sale.amount_paid;
            } else if (!this.orderFormItems.length) {
                this.sale.subtotal = 0;
                this.sale.payable = 0;
                this.sale.tax_amount = 0;
            }
        },
        getCurrencyTitle() {
            return this.currency == null ? "" : "(" + this.currency.title + ")";
        },
        getQuotation() {
            if (this.selectedQuotation == "") {
                this.clearForm();
                return;
            }
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get(
                    "/api/admin/sale_quotation/" +
                    this.selectedQuotation +
                    "?getWarehouse=1&getTax=1&getDetail=1&productDetail=1&getCustomer=1&getProduct=1&getProductCombination=1",
                    config
                )
                .then((res) => {
                    if (res.data.status == "Success") {

                        this.clearFormGetQoutation();
                        this.fetchCurrency();
                        this.fetchWarehouses();
                        this.fetchCustomers();
                        this.fetchProducts();
                        this.fetchTaxes();
                        this.fetchCoupons();

                        this.sale.warehouse_id = res.data.data.warehouse.warehouse_id;
                        this.sale.customer = res.data.data.customer;
                        this.sale.desc = res.data.data.desc;

                        this.getSelectedCustomerData();
                        this.taxApply();
                        this.fetchCouponsByID(res.data.data.coupon_setting_id);

                        for (var k = 0; k < res.data.data.detail.length; k++) {
                            var detail = res.data.data.detail[k];

                            var valObj = this.product_id.filter(function (elem) {

                                if (elem.product_id == detail.product_id.product_id) {
                                    //console.log(elem.product_id + "==" + detail.product_id.product_id);
                                    return elem.product_id;
                                }
                            });

                            if (valObj.length > 0) {
                                //console.log(valObj[0].Value);
                            } else {
                                this.product_id.push({
                                    product_id: detail.product_id.product_id,
                                    detail: detail.product_id.detail,
                                });
                            }


                            //alert(detail.qty);


                            if (detail.product_id.product_type == "simple") {
                                this.addProduct(
                                    {
                                        product_id: detail.product_id.product_id,
                                        qty: detail.qty,
                                    },
                                    detail.product_id.product_id
                                );
                            }
                            if (detail.product_id.product_type == "variable") {
                                var combination_detail = detail.product_id.combination_detail;
                                var product = detail.product_id;

                                //console.log(combination_detail, "working");

                                if (combination_detail.length > 0) {
                                    var arr = {};
                                    for (var i = 0; i < combination_detail.length; i++) {

                                        arr.product_price = combination_detail[i].price;

                                        arr.product_combination_id =
                                            combination_detail[i].product_combination_id;
                                        var combination_name = "";
                                        if (combination_detail[i].combination.length > 0) {
                                            for (
                                                var j = 0;
                                                j < combination_detail[i].combination.length;
                                                j++
                                            ) {
                                                if (j == 0) {
                                                    combination_name =
                                                        combination_detail[i].combination[j].variation
                                                            .detail[0].name;
                                                } else {
                                                    combination_name +=
                                                        "-" +
                                                        combination_detail[i].combination[j].variation
                                                            .detail[0].name;
                                                }
                                                // console.log('i=' + i + 'j=' + j);
                                            }
                                        }

                                        arr.product_id = product.product_id;
                                        arr.product_type = product.product_type;
                                        arr.qty = detail.qty;
                                        arr.stock_status = "";
                                        arr.warehouse = "";
                                        arr.product_price = combination_detail[i].price;

                                        arr.title =
                                            product.detail.length > 0
                                                ? product.detail[0].title +
                                                " (" +
                                                combination_name +
                                                ")"
                                                : "";

                                        if (
                                            parseInt(detail.productCombinationId) ==
                                            parseInt(combination_detail[i].product_combination_id)
                                        ) {
                                            this.addCombinationProduct(
                                                arr,
                                                arr.product_combination_id
                                            );

                                            this.combination_product_id.push({
                                                qty: detail.qty,
                                                stock_status: "",
                                                warehouse: "",
                                                product_id: arr.product_id,
                                                product_combination_id: arr.product_combination_id,
                                                title: arr.title,
                                                product_type: "variable",
                                                product_price: arr.product_price,
                                            });
                                        }
                                        var valObj = this.combination_products.filter(function (elem) {

                                            if (elem.product_combination_id == arr.product_combination_id) {
                                                //console.log(elem.product_combination_id + "==" + arr.product_combination_id);
                                                return elem.product_combination_id;
                                            }
                                        });

                                        if (valObj.length > 0) {
                                            //console.log(valObj[0].Value);
                                        } else {
                                            this.combination_products.push(arr);
                                        }
                                        arr = {};

                                    }
                                }
                            }
                        }
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        clearForm() {
            this.display_form = 0;
            this.display_table = false;
            //this.product_id = "";
            this.selectedQuotation = "";
            this.product_price = [];
            this.product_discount_price = [];
            this.combination_products = [];
            this.combination_product_id = [];
            this.selectedCoupon = {};

            this.sale = {
                desc: "",
                payable: 0,
                discount: 0,
                tax_id: "",
                tax_rate: 0,
                tax_amount: 0,
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                order_status_id:1,
            };

            this.errors = new ErrorHandling();
            this.selectedProducts = [];
            this.selectedCustomerAddress = {};
        },

        clearFormGetQoutation() {
            this.display_form = 0;
            this.display_table = false;
            //this.product_id = "";
            //this.selectedQuotation = "";
            this.product_price = [];
            this.product_discount_price = [];
            this.combination_products = [];
            this.combination_product_id = [];
            this.selectedCoupon = {};

            this.sale = {
                desc: "",
                payable: 0,
                discount: 0,
                tax_id: "",
                tax_amount: 0,
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                order_status_id:1,
            };

            this.errors = new ErrorHandling();
            this.selectedProducts = [];
            this.selectedCustomerAddress = {};
        },

        taxApply() {
            //todo: use customer and product taxes
            this.tax_per_apply = 0;
            var page_url = "/api/admin/warehouse/" + this.sale.warehouse_id;
            axios.get(page_url, this.token).then((res) => {
                //console.log("current warehouse", res.data.data);
                this.warehouse_state_id = res.data.data['warehouse_state_id'];
                if (res.data.status == "Success") {
                    if (res.data.data.warehouse_tax != null) {
                        res.data.data.warehouse_tax.forEach((element) => {
                            this.tax_per_apply =
                                parseFloat(this.tax_per_apply) + parseFloat(element.tax_rate);
                        });
                    }
                }
            });
        },
        save(after = 'close'){
            if(this.type == 'offer'){
                return this.saveOffer();
            }
            return this.saveTransaction(after)
        },
        saveOffer(){
            console.log('saveOffer');
            let products = this.$store.getters['offer/selectedProducts'];
            


            axios.get("/api/admin/customer/" + this.sale.customer.customer_id, this.token).then((res) => {
                if (res.data.status == "Success") {
                    var page_url = "/api/admin/offer";
                    var data = this.buildOrderData(res);
                    data['type'] = 'offer';
                    data['offers'] = products;
                    axios[this.$route.params.id ? 'put' : 'post'](this.$route.params.id ? `/api/admin/offer/${this.$route.params.id}` : page_url, data, this.token)
                        .then((res) => {
                            console.log('prommise');
                            if (res.data.status == "Success") {
                                //this.clearForm();
                                this.$toaster.success(res.data.message);
                                //this.$router.push(this.$route.params.id ? `/admin/order/${this.$route.params.id}` : "/admin/orders");
                            } else {
                                this.$toaster.error(res.data.message);
                            }
                        })
                        .catch((error) => {
                            this.error_message = "";
                            this.errors = new ErrorHandling();
                            if (error.response.status == 422) {
                                if (error.response.data.status == "Error") {
                                    // this.error_message = error.response.data.message;
                                    this.$toaster.error(
                                        error.response.data.message
                                    );
                                } else {
                                    this.errors.record(error.response.data.errors);
                                }
                            }
                        })
                        .finally(() => (this.$parent.loading = false));
                        }
            }).catch((error) => {

            })
            .finally(() => (this.$parent.loading = false));

        },
        saveTransaction(after = 'close') {
            this.errors = new ErrorHandling();
            let err = {};
            let isError = false;

            if (this.sale.warehouse_id == "") {
                err.warehouse_id = ["Warehouse field is required"];
                isError = true;
            }
            if (!this.sale.customer || !this.sale.customer.customer_id) {
                err.customer = ["Customer field is required"];
                isError = true;
            }
            if (!this.orderFormItems.length) {
                err.product_id = ["Добавьте хотя бы один товар"];
                isError = true;
            }

            if (isError) {
                this.errors.record(err);
                return;
            }

            // Rows already live on the server, so the order is built from them
            // directly instead of being pushed through the cart row by row.
            this.$parent.loading = true;

            axios
                .get(`/api/admin/customer/${this.sale.customer.customer_id}`, this.token)
                .then((customer) => {
                    if (customer.data.status !== "Success") {
                        this.$toaster.error(customer.data.message);
                        return;
                    }

                    const editing = this.$route.params.id;
                    const data = this.buildOrderData(customer);
                    const url = editing ? `/api/admin/order/${editing}` : "/api/admin/order";

                    return axios[editing ? "put" : "post"](url, data, this.token).then((res) => {
                        if (res.data.status !== "Success") {
                            this.$toaster.error(res.data.message);
                            return;
                        }

                        this.$toaster.success(res.data.message);

                        // Rows were consumed when the order was built, so staying
                        // on the page means refilling the form from the order.
                        if (after === 'stay') {
                            if (editing) {
                                return this.loadOrderForm();
                            }

                            const created = res.data.data && res.data.data.order_id;

                            if (created) {
                                return this.$router.push(`/admin/order/${created}/edit`);
                            }
                        }

                        this.clearForm();

                        if (after === 'list' || !editing) {
                            return this.$router.push("/admin/orders");
                        }

                        this.$router.push(`/admin/order/${editing}`);
                    });
                })
                .catch((error) => {
                    this.error_message = "";
                    this.errors = new ErrorHandling();

                    if (error.response && error.response.status == 422) {
                        if (error.response.data.status == "Error") {
                            this.$toaster.error(error.response.data.message);
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    } else {
                        this.$toaster.error("Не удалось сохранить заказ");
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCouponsByID(id) {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios.get("/api/admin/coupon_setting/" + id, config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.selectedCoupon = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCoupons() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios.get("/api/admin/coupon_setting", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.coupons = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        showSideBarProduct() {
            let data = this.products;
            this.category_products = [];
            for (let product of data) {
                if (product.product_type == "variable") {
                    for (let combination_detail of product.combination_detail) {
                        // product.combination_detail[k].available_qty;
                        let product_name = product.detail[0].title + " ";
                        for (let m = 0; m < combination_detail.combination.length; m++) {
                            if (combination_detail.combination.length - 1 == m) {
                                product_name += combination_detail.combination[m].variation.detail[0].name;
                            } else {
                                product_name += combination_detail.combination[m].variation.detail[0].name + "_";
                            }
                        }
                        var parms = {};
                        parms["product_name"] = product_name;
                        parms["product_id"] = product.product_id;
                        parms["product_type"] = product.product_type;
                        parms["product_combination_id"] =
                            combination_detail.product_combination_id;
                        parms["product_price"] = combination_detail.price;
                        this.category_products.push(parms);
                    }
                } else {
                    var parms = {};
                    parms["product_name"] = product.detail[0].title;
                    parms["product_id"] = product.product_id;
                    parms["product_combination_id"] = "";
                    parms["product_type"] = product.product_type;
                    parms["product_price"] = product.product_price;
                    parms["product_discount_price"] =
                        product.product_discount_price > 0
                            ? product.product_discount_price
                            : product.product_price;
                    this.category_products.push(parms);
                }
            }
        },
        async addProduct(selectedOption, id) {
            this.errors = new ErrorHandling();
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            await axios
                .get("/api/admin/product/" + selectedOption.product_id + "?getDetailWithLanguage=1&getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.customIndex = 0;
                        var arr = {};
                        if (res.data.data.product_type == "simple") {
                            arr.product_id = res.data.data.product_id;
                            arr.product_type = res.data.data.product_type;
                            arr.title =
                                res.data.data.detail.length > 0
                                    ? res.data.data.detail[0].title
                                    : "";
                            arr.product_combination_id = null;
                            arr.qty = selectedOption.qty;
                            arr.stock_status = "";
                            arr.warehouse = "";
                            arr.available_qty = res.data.data.available_qty;
                            arr.product_sku = res.data.data.product_sku;
                            arr.product_price = res.data.data.product_price;
                            arr.product_price_with_vat = res.data.data.product_price_with_vat;
                            arr.product_discount_price_with_tax = res.data.data.product_result_price_with_vat;
                            arr.product_discount_price =
                                res.data.data.product_discount_price > 0
                                    ? res.data.data.product_discount_price
                                    : res.data.data.product_price_with_vat;
                            this.sale.qty.push(selectedOption.qty);
                            //arr.tax_rate = res.data.data.product_tax.tax_rate;
                            arr.tax_rate = res.data.data.product_tax_rate;
                            this.selectedProducts.push(arr);
                        } else {
                            if (res.data.data.combination_detail.length > 0) {
                                for (let combination_detail of res.data.data.combination_detail) {
                                    arr.product_price = res.data.data.product_tax_rate > 0
                                            ? (combination_detail.price/parseFloat(res.data.data.product_tax_rate/100+1)).toFixed(3)
                                            : combination_detail.price
                                    arr.product_price_with_vat = combination_detail.price;
                                    arr.product_discount_price_with_tax = combination_detail.product_result_price_with_vat
                                    arr.product_discount_price = combination_detail.product_discount_price


                                    arr.product_combination_id = combination_detail.product_combination_id;
                                    arr.available_qty = combination_detail.available_qty;
                                    arr.product_sku = combination_detail.sku;

                                        var combination_name = "";
                                    if (combination_detail.combination.length > 0) {
                                        for (var j = 0; j < combination_detail.combination.length; j++) {
                                            if (j == 0) {
                                                combination_name = combination_detail.combination[j].variation.detail[0].name;
                                            } else {
                                                combination_name += "-" + combination_detail.combination[j].variation.detail[0].name;
                                            }
                                        }
                                    }
                                    arr.product_id = res.data.data.product_id;
                                    arr.product_type = res.data.data.product_type;
                                    arr.qty = selectedOption.qty;
                                    arr.stock_status = "";
                                    arr.warehouse = "";
                                    arr.ean = combination_detail.ean;
                                    arr.title =
                                        res.data.data.detail.length > 0
                                            ? res.data.data.detail[0].title + " (" + combination_name + ")"
                                            : "";
                                    //arr.tax_rate = res.data.data.product_tax.tax_rate;
                                    arr.tax_rate = res.data.data.product_tax_rate;
                                    this.combination_products.push(arr);
                                    //alert ("i am here and working in some scenario");
                                    arr = {};
                                }

                            }
                        }
                        this.display_table = true;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },

        async addStartProduct(selectedOption, orderProduct) {
            this.customIndex = 0;
            let arr = {};
            if (orderProduct.product_type == "simple") {
                arr.product_id = orderProduct.product_id;
                arr.product_type = orderProduct.product_type;
                arr.title = orderProduct.product_title;
                arr.product_combination_id = null;
                arr.qty = selectedOption.qty;
                arr.stock_status = "";
                arr.warehouse = "";
                arr.available_qty = orderProduct.available_qty;
                arr.product_sku = orderProduct.product_sku;
                arr.product_price = orderProduct.product_price;
                arr.product_price_with_vat = orderProduct.product_price_with_vat;
                arr.product_discount_price_with_tax = orderProduct.product_result_price_with_vat;
                arr.product_discount_price =
                    orderProduct.product_discount_price > 0
                        ? orderProduct.product_discount_price
                        : orderProduct.product_price_with_vat;
                this.sale.qty.push(orderProduct.qty);
                arr.tax_rate = orderProduct.product_tax_rate;
                this.selectedProducts.push(arr);
            } else {
                if (orderProduct.combination_detail.length > 0) {
                    for (let combination_detail of orderProduct.combination_detail) {
                        arr.product_price = orderProduct.product_tax_rate > 0
                            ? (combination_detail.price/parseFloat(orderProduct.product_tax_rate/100+1)).toFixed(3)
                            : combination_detail.price
                        arr.product_price_with_vat = combination_detail.price;
                        arr.product_discount_price_with_tax = combination_detail.product_result_price_with_vat
                        arr.product_discount_price = combination_detail.product_discount_price
                        arr.product_combination_id = combination_detail.product_combination_id;
                        arr.available_qty = combination_detail.available_qty;
                        arr.product_sku = combination_detail.sku;

                        var combination_name = "";
                        if (combination_detail.combination.length > 0) {
                            for (var j = 0; j < combination_detail.combination.length; j++) {
                                if (j == 0) {
                                    combination_name = combination_detail.combination[j].variation.detail[0].name;
                                } else {
                                    combination_name += "-" + combination_detail.combination[j].variation.detail[0].name;
                                }
                            }
                        }
                        arr.product_id = orderProduct.product_id;
                        arr.product_type = orderProduct.product_type;
                        arr.qty = selectedOption.qty;
                        arr.stock_status = "";
                        arr.warehouse = "";
                        arr.ean = combination_detail.ean;
                        arr.title =
                            orderProduct.product_title.length > 0
                                ? orderProduct.product_title + " (" + combination_name + ")"
                                : combination_name;
                        arr.tax_rate = orderProduct.product_tax_rate;
                        this.combination_products.push(arr);
                        arr = {};
                    }
                }
            }
            this.display_table = true;
            this.$parent.loading = false
        },
        buildOrderData(customer = null){
            return {
                        code: this.sale.code,
                        is_add_sale: "1",
                        warehouse_id: this.sale.warehouse_id,
                        billing_first_name: customer?.data.data.customer_first_name,
                        billing_last_name: customer?.data.data.customer_last_name,
                        billing_street_address: this.sale.billing_street_address,
                        billing_country: this.sale.billing_country.country_id,
                        billing_state: this.warehouse_state_id,
                        billing_city: this.sale.billing_city,
                        billing_postcode: this.sale.billing_postcode,
                        billing_phone: this.sale.billing_phone
                            ? this.sale.billing_phone
                            : null,

                        delivery_first_name: customer?.data.data.customer_first_name,
                        delivery_last_name: customer?.data.data.customer_last_name,
                        delivery_street_address: this.sale.billing_street_address,
                        delivery_country: this.sale.billing_country.country_id,
                        delivery_state: this.warehouse_state_id,
                        delivery_city: this.sale.billing_city,
                        delivery_postcode: this.sale.billing_postcode,
                        delivery_phone: this.sale.billing_phone
                            ? this.sale.billing_phone
                            : null,
                        order_notes: this.sale.order_notes,
                        coupon_code: this.selectedCoupon
                            ? this.selectedCoupon.coupon_code
                            : "",
                        latlong: "12312312312",
                        currency_id: "1",
                        payment_method_id: this.sale.payment_method_id,
                        // Looked up by id — method ids are not contiguous, so indexing
                        // the array by (id - 1) picked the wrong method or nothing.
                        payment_method: this.payment_methods.find(
                            item => Number(item.payment_method_id) === Number(this.sale.payment_method_id)
                        )?.payment_method_name,
                        shipping_method_id: this.sale.shipping_method_id,
                        shipping_option_id: this.sale.shipping_option_id,
                        shipping_cost: this.sale.shipping_cost,
                        customer_id: this.sale.customer?.customer_id,
                        order_status_id: this.sale.order_status_id ?? "1",
                        bill_note: this.sale.bill_note ?? "",
                        internal_note: this.sale.internal_note ?? "",
                        created_at: this.sale.sale_date ?? null,
                        billing_company_address: this.sale.billing_company_address,
                        company_id: this.sale.company_id,
                    };
        },
        addCombinationProduct(selectedOption, id) {
            this.selectedProducts.push(selectedOption);
            this.sale.qty.push(selectedOption.qty);
            setTimeout(() => {
                this.computeValues('addCombinationProduct');
            }, 300);
        },
        removeItem(removedOption, id) {
            //console.log(removedOption);
            // check if key exists
            const hasKey = "product_combination_id" in removedOption;
            if (hasKey) {
                if (
                    removedOption.product_combination_id != null &&
                    removedOption.product_combination_id != ""
                ) {
                    this.selectedProducts.forEach((el, index) => {
                        if (el.product_combination_id == removedOption.product_combination_id) {
                            this.selectedProducts.splice(index, 1);
                            this.sale.qty.splice(index, 1);
                            this.sale.price.splice(index, 1);
                            this.sale.product_combination_id.splice(index, 1);
                            this.sale.product_id.splice(index, 1);
                            this.sale.discount.splice(index, 1);
                            this.sale.discount_price_with_tax.splice(index, 1);
                        }
                    });

                    this.combination_product_id = this.combination_product_id.filter(
                        function (el) {
                            return (
                                el.product_id != removedOption.product_id &&
                                el.product_combination_id !=
                                removedOption.product_combination_id
                            );
                        }
                    );
                }
            } else {
                this.selectedProducts.forEach((el, index) => {
                    if (el.product_id == removedOption.product_id) {
                        this.selectedProducts.splice(index, 1);
                        this.sale.qty.splice(index, 1);
                        this.sale.price.splice(index, 1);
                        this.sale.product_combination_id.splice(index, 1);
                        this.sale.product_id.splice(index, 1);
                        this.sale.discount.splice(index, 1);
                        this.sale.discount_price_with_tax.splice(index, 1);
                    }
                });

                this.combination_product = this.combination_products.filter(function (el) {
                    //console.log(el);
                    return el.product_id != removedOption.product_id;
                });
                this.combination_products = this.combination_products.filter(item => item.product_id !== removedOption.product_id);

            }
            // this.selectedProducts.splice(index, 1);
            // this.stock.qty.splice(index, 1);
            setTimeout(() => {
                this.computeValues('removeProduct');
            }, 300);
        },
        nameWithLang(option) {
            let name = option.detail[0].title;

            if(option.product_ean) {
                name += " - "+option.product_ean;
            }

            if(option.product_sku) {
                name += " - "+option.product_sku;
            }

            if(option.product_barcodes) {
                name += " - "+option.product_barcodes;
            }
            if(option.product_barcode) {
                name += " - "+option.product_barcode;
            }

            if(option.stocks && option.stocks[0]) {
                name += " ("+option.stocks[0].remaining+")";
            }
            return name;
        },
        nameWithLangVariation(option) {
            let name = option.title;

            if(option.ean) {
                name += " - "+option.ean;
            }

            if(option.stocks && option.stocks[0]) {
                name += " ("+option.stocks[0].remaining+")";
            }
            return name;
        },
        customerNameSurname(option) {
            return (option.customer_first_name && option.customer_last_name) ? option.customer_first_name+" "+option.customer_last_name+" ("+option.customer_email+")" : option.customer_email;
        },
        countryName(option) {
            return (option.country_name ) ? option.country_name : "unknown";
        },
        companyName(option) {
            return (option.name ) ? option.name : "unknown";
        },
        getOrder(){
            this.errors = new ErrorHandling();
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get(`/api/admin/order/${this.$route.params.id}?orderDetail=1&productDetail=1&currency=1&billing_country=1&billing_state=1&delivery_country=1&delivery_state=1&customer=1`, config)
                .then(({data}) => {
                    data = data.data;
                    let date = data.order_date.split('/').reverse();
                    date[0] = `20${date[0]}`;
                    this.sale.code = data.code;
                    this.sale.customer = this.customers.find(item => item.customer_id === data.customer_id);
                    this.sale.billing_street_address = data.billing_street_address;
                    this.sale.billing_postcode = data.billing_postcode;
                    this.sale.billing_city = data.billing_city;
                    this.sale.billing_country = this.countries.find(item => item.country_id === data.billing_country);
                    this.sale.billing_email = data.customer?.customer_email;
                    this.sale.billing_phone = data.billing_phone === 'no phone number' ? '' : data.billing_phone;
                    this.sale.billing_registration_number = data.customer?.customer_registration_number;
                    this.sale.billing_tax_number = data.customer?.customer_tax_number;
                    this.sale.billing_is_legal_person = this.sale.billing_registration_number && this.sale.billing_tax_number;
                    this.sale.billing_company_address = data.billing_company_address || data.customer?.company_address;
                    this.sale.warehouse_id = data.warehouse_id;
                    this.sale.sale_date = date.join('-');
                    this.sale.payment_method_id = data.payment_method_detail?.payment_method_id;
                    this.sale.payment_method = data.payment_method_detail?.payment_method_name;
                    this.sale.shipping_method_id = data.shipping_method_detail?.shipping_method_id;
                    if(data.shipping_option_detail) {
                        this.sale.shipping_option_id = data.shipping_option_detail?.shipping_option_id;
                        this.fetchShippingOptions();
                    }
                    this.sale.shipping_cost= data.shipping_cost;
                    this.sale.order_id = data.order_id;
                    this.sale.order_status_id = data.order_status?.id;
                    this.sale.internal_note = data.internal_note;
                    this.sale.bill_note = data.bill_note;
                    this.sale.company_id = data.company_id;
                    if (data.type == 'offer') {
                        this.type = 'offer';
                        this.$store.dispatch('offer/fetchProducts', data.order_id);
                        this.fetchOfferTotal();
                    }

                    // Rows are loaded by loadOrderForm() from the server; the form
                    // no longer rebuilds them from parallel arrays here.


                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchOfferTotal(){
            var data = this.buildOrderData();
            data['type'] = 'offer';
            data['offers'] = this.$store.getters['offer/selectedProducts'];

            axios.post("/api/admin/offer-calculate", data, this.token)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.offer_totals = res.data.data;
                    }
                })
        }
    },
    mounted() {
        if(this.$route.meta.type){
            this.type = this.$route.meta.type;
        }
        var token = localStorage.getItem("token");
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const productsLoaded = this.fetchProducts();
        this.fetchSaleQuotations();
        this.fetchCurrency();
        this.fetchWarehouses();
        
        this.fetchTaxes();
        this.fetchCoupons();
        this.fetchPaymentMethods();
        this.fetchShippingMethods();
        this.fetchCountries();
        this.fetchCompanies();

        Promise.all([this.fetchCustomers(), productsLoaded]).then(() => {
            if (this.$route.params.id) {
                this.getOrder();
                this.fetchOrderStatuses();
                this.loadOrderForm();
            }
        });
    },
    watch:{
        $route (to, from){
            location.reload();
        },

        'sale.shipping_cost' (to, from){
            this.fetchOfferTotal();
        },

        '$store.state.offer.selectedProducts': {
            handler(newSelectedProducts, oldSelectedProducts) {
                this.fetchOfferTotal();
            },
            deep: true,
        },

    },
    computed: {
        currencySymbol() {
            return window.appConfig?.currencySymbol || '€';
        },
        shippingPrice() {
            return Number(this.sale.shipping_cost.toString().replace(',','.'))
        },
        productsCount(){
            return this.orderFormItems.reduce((sum, item) => sum + Number(item.qty || 0), 0);
        }
    }
};
</script>
